module.exports = __webpack_public_path__ + "static/media/pvcBlanco10.c601260b.jpg";